import PropTypes from "prop-types";
import React from "react";
import Card from "react-bootstrap/Card";

function CardBasic(props) {
  const {
    className,
    header,
    footer,
    headerClassName,
    bodyClassName,
    footerClassName,
    children,
  } = props;
  return (
    <Card className={className}>
      {header && (
        <Card.Header className={headerClassName}>{header}</Card.Header>
      )}
      {children && <Card.Body className={bodyClassName}>{children}</Card.Body>}
      {footer && (
        <Card.Footer className={footerClassName}>{footer}</Card.Footer>
      )}
    </Card>
  );
}

export const propTypes = {
  className: PropTypes.string,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  headerClassName: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  bodyClassName: PropTypes.string,
  footer: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  footerClassName: PropTypes.string,
};

CardBasic.propTypes = propTypes;

export default CardBasic;
